import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'

const resources = {
  en: {
    translation: {
      'VodafoneCashInstapay': 'Vodafone Cash & Instapay',
      'reset_image_required': 'Reset Image is required',
      'reset_image': 'Reset Image',
      'YourOrders': 'Orders History',
      'About': 'About us',
      'Blogs': 'Blogs',
      'Contact': 'Contact',
      'Home': 'Home',
      'Shop': 'Shop',
      'ShopByCategory': 'Shop By Category',
      'GiftAndBundle': 'Gift & Bundle',
      'Categories': 'Categories',
      'SeeOurBundels': 'See Our Bundels',
      'GetYourBundleRightNow': 'Get your bundle right now',
      'ShopNow': 'Shop now',
      'ViewAll': 'View All',
      'ElegantModernModest': 'Elegant  Modern  Modest',
      'MeMaSGirls': "MeMa's Girls",
      'SubscribeDesc': 'Communicate with us and get 10% off!',
      'Bundles': 'Bundles',
      'CATALOG': 'CATALOG',
      'OrdersHistory': 'Orders History',
      'DiscoverMoreAboutMeMa': 'Discover more about MeMa',
      'DiscoverMoreAboutMeMaDesc': `we offer a wide range of hijabs to suit every style and occasion. From classic to modern 
      designs, our collection blends comfort, elegance, and versatility. Find the perfect piece that complements your
      look and enhances your confidence every day.`,
      'Whoweare': `Who we are ?`,

      'WhoDesc1': `At MiMa Store, we are more than just a hijab retailer; we are a brand committed to empowering women
       through fashion. Our journey began with a vision to provide modern, stylish hijabs that meet the diverse needs 
       of women who embrace modesty. We believe that every woman deserves to feel beautiful,  confident, and comfortable 
       in her own skin, and our collection is thoughtfully designed to reflect that.`,

      'WhoDesc2': `Our team is dedicated to curating high-quality fabrics, unique designs, and timeless styles that 
       seamlessly blend tradition with modern fashion. Each piece is crafted with attention to detail, ensuring that
       you can express your individuality while staying true to your values. Whether you're dressing for a special 
       occasion or looking for everyday wear, MiMa Store offers versatile options that cater to all your needs.`,

      'WhoDesc3': `We take pride in our commitment to quality, customer satisfaction, and sustainability. By choosing MiMa 
      Store, you are not just purchasing a product – you are investing in a brand that values integrity, celebrates 
      diversity, and is devoted to making you feel your best.`,

      'WhyMemaStore': 'Why Mema Store ?',

      'WhyMemaDesc': `At MeMa Store, we celebrate modesty with a flair for fashion. Our collection of high-quality, 
      stylish hijabs is designed to meet every need, whether you're looking for everyday wear or something special 
      for an occasion. We are committed to providing comfort, elegance, and versatility, ensuring that every piece
      enhances your confidence and beauty. Choose MeMa Store for a perfect blend of tradition and modernity, crafted 
      with care just for you.`,

      'Yourstyle': 'Your style is our passion',

      'MeMaBlogs': `MeMa's blogs`,

      'MeMaBlogsDesc': `Mema Store blog for the latest trends, style tips, and behind-the-scenes insights. Our articles 
      offer valuable advice on how to make the most of your hijab collection, stay updated on fashion trends, and get
      inspired for every occasion. Stay connected with us and elevate your style with expert tips and exclusive content.`,

      'GetInTouch': 'Get In Touch',

      'GetInTouchDesc': `We’d love to hear from you! For any questions, feedback, or assistance, reach out to our
      team at MiMa Store. Whether you need help with your order, have a style inquiry, or just want to share your 
      thoughts, we’re here to assist you. Contact us via email, phone, or our online form, and we’ll get back to you promptly.`,

      'FullName': 'Full Name',
      'Email': 'Email',
      'OrderNumber': `Order Number`,
      'Subject': `Subject`,
      'Message': `Message`,
      'SubmitMessage': 'Submit Message',
      'NameIsRequired': 'Name is required',
      'EmailIsRequired': 'Email is required',
      'SubjectIsRequired': 'Subject is required',
      'MessageIsRequired': 'Message is required',
      'ShouldBeEmailPlease': 'Should be email please',

      'Login': 'Login',
      'EmailorPhoneNumber': 'Email or Phone Number',
      'Password': 'Password',
      'ForgetPassword': 'Forget Password?',
      'SignIN': 'SIGN IN',
      'ConfirmPassword': 'Confirm Password',
      'Phone': 'Phone',

      'CreateAccount': 'Create Acconut',
      'EmailOrPhonePlease': 'Email or Phone please',
      'PasswordIsRequired': 'Password is required',
      'ConfirmPasswordRequired': 'Pleae password should be confirmed',
      'MatchedIsRequired': 'Password must be matched with Confirmation',
      'PhoneIsRequired': 'Please provide a phone number',
      'PhoneValid': 'Phone number must be valid for Saudi Arabia or Egypt',

      'Already': 'Already have accound',
      'ResetYourPassword': 'Reset your password',
      'BackToLogin': 'Back To Login',
      'SendMail': 'Send Mail',
      'ChangePassword': 'Change Password',

      'Cart': 'Cart',
      'EmptyCart': 'Your cart is empty',
      'Clear': 'Clear',
      'Copon': 'Copon',
      'CheckOut': 'Check Out',

      'WishList': `Wish List`,
      'EmptyWishList': `Your WishList is empty`,
      'PleaseWishList': `Please you should login or created account first`,

      'MeMaAllProducts': `MeMa's All Products`,
      'Filter': 'Filter',
      'Products': 'Products',
      'and': 'and',

      'Price': 'Price',
      'DiscoverOurBundle': `Discover Our Bundle`,
      'LE': 'LE',
      'SAR': 'SAR',
      'Remove': 'Remove',
      'Fibrac': 'Fabric ',
      'OurVariants': 'Our Variants',
      'MixedColor': 'Mixed Color',
      'Qunatatiy': 'Qunatatiy',

      'InSotckReadyToShip': 'In Sotck, ready to ship',
      'GetItBeforeFinished': 'Get it before finished',

      'OutOfTheStock': 'Out of the stock',
      'AddToCart': 'Add To Cart',
      'BuyItNow': 'Buy It Now',
      'Reviews': 'Reviews',
      'YouMayAlsoLike': 'You may also like',

      'AddReview': `Add Review`,
      'ReviewTitle': `Review Title`,
      'Review': 'Review',
      'PleaseAddYourReviewTitle': `Please add your review's Title`,
      'PleaseAddYourReview': `Please add your review`,
      'GiveYourReviewTitle': `Give Your Review Title`,
      'GiveYourReview': `Give Your Review`,
      'YourAddition': 'Addition total price',
      'BundleSProduct': `Bundle's Product`,
      'YourAddress': 'Your Address',
      'YourAddressIsRequired': 'Your Address is required',
      'placed': 'Placed',
      'OrderDate': `Order Date`,
      'OrderProducts': 'Order Products',
      'Quantity': 'Quantity',
      'TotalAdditions': `Total Additions`,
      'DiscountPrecentage': `Discount Precentage`,
      'ReviewDesc': `How we use your data: We’ll only contact you about the review you left, and only if
      necessary. By submitting your review, you agree to Judge.me’s terms, privacy and content policies.
      Reviews`,
      'SendReview': 'Send Review',

      'Shipping': `We advise the customer to make sure to open the shipment after receiving it and inform us within
      a maximum of 72 hours of any problem with the order after examining the designs well to help you with any return or
      exchange because no exchange or return is available after that and because we are keen to examine all products before 
      shipping them, but we appreciate the nature of the error rate, so we advise you to examine the order well after receiving 
      it to preserve your right.Shipping and Delivery All orders are shipped within 4-7 business days. The shipping company
      will contact you to arrange the delivery date.All our orders are hand-packed and shipped with love from Cairo, Egypt.`,

      'ShippingTitle': 'Shipping',

      'ProductCare': `Product Care`,

      'ProductCareDesc': `Always wash each scarf alone Make sure you use cool water and a mild soap like downy. Don't use 
      bleach or strong detergent like Persil Gel. Do not soak your scarf.`,

      'ProductCareDesc2': `Care: Don't use pins in any scarf you have, they ruin your scarves, snag at them and leave 
      nasty pin marks. You can use our magnetic pins instead or just wrap them loosely. That's the universal recommendation
      for caring for any delicate scarf you may have.`,

      'ProductCareDesc3': `Wash under running water, not in a full sink. Gently squeeze it 
      (don't scrub the scarf, & never wring it!). Lay the scarf flat to dry, don't hang so it can keep it's shape.`,

      'ProductCareDesc4': `Also laying it flat ensures that the different colored parts don't touch each other while wet 
      to avoid color transfer (applicable for all Ombre & deep dyed scarves) Ironing: Iron on low and preferably have 
      another piece of cloth between the scarf and the iron.`,

      'SizeDescription': 'Size Description',
      'Dashboard': 'Dashboard',

      'LogOut': 'Log Out',
      'MyAccount': 'My Account',
      'SeeYourOrders': 'See Your Orders',
      'Egypt': 'Egypt',
      'SaudiArabia': 'Saudi Arabia',
      'AccountDetails': 'Account Details',
      'Address': 'Address',
      'SendAddress': 'Send Address',

      'Information': 'Information',
      'FAQ': 'FAQ',
      'RefundAndExchange': `Refund And Exchange`,
      'Connection': 'Connection',
      'Egy': 'Egy phone',
      'Sud': 'Sud phone',
      'Rights': `© 2024 MeMa. All rights reserved Designed By A To Z Tech`,
      'apartment': 'Apartment',
      'city': 'City',
      'state': 'State',
      'Coupon': 'Coupon',
      'PleaseApartmentIsAequired': 'Please apartment is required',
      'PleaseYourCountryIsRequired': `Please your country is required`,
      'ShippingCost': 'Shipping',
      'ToTalPrice': 'Total',
      'FrequentlyAskedQuestions': `Frequently Asked Questions`,
      'FreqDesc': `MeMa Store website is crucial for enhancing customer satisfaction. It provides quick,
                    easy-to-find answers to common questions about products, shipping, returns, and store policies.
                    By offering this helpful resource, MeMa Store ensures that customers can resolve their concerns
                    efficiently without needing to contact support, leading to a smoother shopping experience. Regularly
                    updated with the most relevant information, the FAQ section serves as a go-to resource for both new and
                    returning customers.`,
      'HowScarves': `How to wash and care for my mema scarves?`,
      'HandClean': `Cleaning: Kindly check the wash instructions listed for each scarf in its product page. If spot cleaning is needed, make sure to wash only the spot intended, and 
                        that the differently colored parts of the scarf don't touch at all while wet, to avoid color transfer.If Hand Wash is recommended,Always wash each scarf alone.Make sure you use
                        cool water and a mild soap like downy. Don't use bleach or strong detergent like Persil Gel.Do not soak your scarf.Wash under running water, not in a full sink.Gently squeeze it 
                        (don't scrub the scarf, & never wring it!). Lay the scarf flat to dry, don't hang so it can keep it's shape.Also laying it flat ensures that the different colored parts don't touch
                        each other while wet to avoid color transfer (applicable for all Ombre & deep dyed scarves) Ironing: Iron on low and preferably have another piece of cloth between the scarf and the iron.
                        Care: Don't use pins in any scarf you have, they ruin your scarves, snag at them and leave nasty pin marks. You can use our magnetic pins instead or just wrap them loosely.
                        That's the universal recommendation for caring for any delicate scarf you may have.`,
      'HowToCancel?': 'How can I edit or cancel my order?',
      'CancelDesc': `Please contact us in case of changing your information or cancelling your order 
                    on Instagramor Facebook Please provide us with your order number and a screenshot of your
                    order confirmation on email to be able to assist you and the changes needed to be implemented.`,
      'CityRequired': 'Please Your City is needed',
      'PrivacyAndPolicy': 'Privacy And Policy',
      'ShippingOrder': 'Shipping',
      'REFUNDANDEXCHANGE': `REFUND AND EXCHANGE`,

      'RefundPolicyTitle': `سياسة الاستبدال والاسترجاع`,
      'RefunDesc': `يمكنك معاينة واسترجاع طلبك أثناء وجود المندوب عند التسليم. يرجى معاينة الطلب عند استلامه، وإذا لم يكن مطابقًا لتوقعاتك، يُرجى إرجاعه إلى المندوب فورًا 💕`,
      'NewArrival': `اخر منتجاتنا`,
      'RefunDesc2': `مع العلم انه غير متاح تسليم جزئي للأوردر 🎀`,
      'RefunDesc3': `يرجى ملاحظة أننا لا نقبل الاسترجاع بعد مغادرة المندوب وغير مسئولين عن الأوردر تمامًا عشان كده بنأكد علي حضرتك مراجعة الأوردر قبل الاستلام.`,
      'RefunDesc4': `هنستني رايك بعد الاستلام بإذن الله 🌸`,
      'RefunDesc5': `ملبوس العافية 🤍🤍`,
      'NewArrival': `New Arrival`,
      'ToTalCart': 'ToTal Cart Price',
      'CouponPrec': 'Discount',
      'subcartprice': 'Subtotal',
      'ProductLink': `Product Vedio Link`,
      'SoldOut': 'Sold Out',
      'PasswordMustBeAtLeast9Characters': 'Password Must Be AtLeast 9 Characters',
      'PasswordMustBeAtMost15Characters': 'Password Must Be At Most 18 Characters',
      'ProductCartSmall': `Hand-wash using cold water, Use mild soap like downy.Dont use bleach or strong detergent .,
      and hang to dry.Iron on medium heat. Store with similar fabric in a ventilated area.Only use magnetic
      pins to prolong the product's life.`,
      'ShippingSmall': `All orders are shipped within 2-6 business days of placement. The shipping company will 
      contact you to arrange a dropoff time.All our orders are hand-packed and shipped with love from Cairo, Egypt.`,
      'DepositNoteTitle': 'Shipping Payment',
      'OrderConfirmIntro': 'To confirm the order, please transfer the shipping cost to:',
      'PaymentVodafone': 'Vodafone Cash under the name MeMa',
      'PaymentInstapay': 'Instapay under the name Ahmed',
      'OrderPaidAtDelivery': 'The order amount will be paid upon delivery, God willing 🌸',
      'ScreenshotConfirmNote': 'Please when transferring, send a screenshot for confirmation on the same WhatsApp number or on the Instagram or Facebook page 🎀',
      'reset_image_note': 'Upload a reference image for your deposit screenshot.',
      'reset_image_note_label': 'What is this for?',
      'reset_image_note_text': 'Upload an image to show us exactly what you want. For example:',
      'reset_image_note_style': 'Style or design you like',
      'reset_image_note_color': 'Color or fabric reference',
      'reset_image_note_embroidery': 'Embroidery or print pattern',
      'reset_image_note_custom': 'Any custom idea for your order',
      'reset_image_optional': 'Optional — Skip if you don\'t have a reference.',
      'reset_image_whatsapp': 'Can\'t upload? You can send your reference image on WhatsApp after submitting your order. Please send it to us on WhatsApp.',
      'ShippingZonesTitle': 'Shipping by Delivery Zone',
      'ShippingZonesIntro': 'Shipping cost depends on your Delivery Zone. The amount you send via Vodafone Cash is the shipping fee, not a deposit.',
      'ShippingZone1': 'Zone 1 (Cairo, Giza): 70 LE',
      'ShippingZone2': 'Zone 2 (Borg Al Arab, Alexandria): 80 LE',
      'ShippingZone3': 'Zone 3 (Port Said, Ismailia, Suez, Qaliyobiya, Menoufia, Sharqiyah, Gharbiya, Dakahlia, Bahira, Damietta, Kafr El Sheikh): 75 LE',
      'ShippingZone4': 'Zone 4 (Fayoum, Beni Suef, Miniya, Assiut, Sohag): 100 LE',
      'ShippingZone5': 'Zone 5 (Qena, Luxor, Aswan): 110 LE',
      'ShippingTableZone': 'Zone',
      'ShippingTableAreas': 'Areas',
      'ShippingTablePrice': 'Price',
      'ShippingZone1Areas': 'Cairo, Giza',
      'ShippingZone1Price': '70 LE',
      'ShippingZone2Areas': 'Borg Al Arab, Alexandria',
      'ShippingZone2Price': '80 LE',
      'ShippingZone3Areas': 'Port Said, Ismailia, Suez, Qaliyobiya, Menoufia, Sharqiyah, Gharbiya, Dakahlia, Bahira, Damietta, Kafr El Sheikh',
      'ShippingZone3Price': '80 LE',
      'ShippingZone4Areas': 'Fayoum, Beni Suef, Miniya, Assiut, Sohag',
      'ShippingZone4Price': '100 LE',
      'ShippingZone5Areas': 'Qena, Luxor, Aswan',
      'ShippingZone5Price': '110 LE',
      'OrderSummary': 'Order Summary',
    }
  },
  ar: {
    translation: {
      'VodafoneCashInstapay': 'فودافون كش و انستاباي',
      'reset_image_required': 'صورة الطلب مطلوبة',
      'reset_image': 'صورة الطلب',
      'YourOrders': 'الطلبات السابقه',
      'About': 'من نحن ؟',
      'Blogs': 'مقالتنا',
      'Contact': 'تواصل معنا',
      'Home': 'الرئيسية',
      'Shop': 'التسوق',
      'ShopByCategory': 'التسوق بالنوع',
      'GiftAndBundle': 'الهدايا و العروض',
      'Categories': 'فئات المنتجات',
      'SeeOurBundels': 'أكتشف عروضنا',
      'GetYourBundleRightNow': 'أحصل علي العرض المناسب الأن',
      'ShopNow': 'تسوق الآن',
      'ViewAll': 'تسوق الآن',
      'ElegantModernModest': 'أنيقة حديثة متواضعة',
      'MeMaSGirls': 'فتيات ميما',
      'SubscribeDesc': `تواصل معنا الأن و أحصل علي كود خصم 10 %`,
      'Bundles': 'عروضنا',
      'CATALOG': 'فئات منتجاتنا',
      'OrdersHistory': 'جميع المشتريات',

      'DiscoverMoreAboutMeMa': 'اكتشف المزيد عن ميما.',

      'DiscoverMoreAboutMeMaDesc': `نحن نقدم مجموعة واسعة من الحجاب لتناسب كل الأذواق والمناسبات. من التصاميم الكلاسيكية إلى الحديثة، مجموعتنا تمزج بين الراحة
      والأناقة والتنوع. ابحث عن القطعة المثالية التي تكمل مظهرك وتعزز ثقتك بنفسك كل يوم.`,

      'Whoweare': `من نحن ؟`,

      'WhoDesc1': `في متجر ميما نحن
      أكثر من مجرد متجر تجزئة للحجاب؛ نحن علامة تجارية ملتزمة بتمكين المرأة من خلال الموضة. بدأت رحلتنا برؤية
      لتوفير حجاب عصري وأنيق يلبي الاحتياجات المتنوعة للمرأة التي تحتضن التواضع. نحن نؤمن بأن كل امرأة تستحق 
      أن تشعر بالجمال والثقة والراحة في بشرتها، وقد صُممت مجموعتنا بعناية لتعكس ذلك.`,

      'WhoDesc2': `فريقنا مكرس لرعاية الأقمشة عالية الجودة والتصميمات الفريدة والأنماط الخالدة التي تمزج التقاليد مع الموضة
      الحديثة بسلاسة. تم تصميم كل قطعة مع الاهتمام بالتفاصيل، مما يضمن أنه يمكنك التعبير عن شخصيتك الفردية مع
      الحفاظ على وفائك لقيمك. سواء كنت ترتدي ملابس لمناسبة خاصة
      أو تبحث عن ملابس يومية، يقدم متجر ميما خيارات متعددة تلبي جميع احتياجاتك.`,

      'WhoDesc3': `نحن نفخر بالتزامنا بالجودة ورضا العملاء والاستدامة. باختيارك متجر ميما فإنك لا تشتري منتجًا فحسب
      - بل تستثمر في علامة تجارية تقدر النزاهة، وتحتفل بالتنوع، وتكرس جهودها لتجعلك تشعر بأفضل ما لديك.`,

      'WhyMemaStore': 'لماذا متجر ميما ؟',

      'WhyMemaDesc': `في متجر ميما، نحتفل بالتواضع مع لمسة من الموضة. مجموعتنا من الحجابات الأنيقة عالية الجودة مصممة لتلبية جميع الاحتياجات، سواء كنت تبحثين عن ملابس يومية أو شيء خاص لمناسبة ما. نحن ملتزمون بتوفير الراحة والأناقة 
      والتنوع، مما يضمن أن كل قطعة تعزز ثقتك بنفسك وجمالك. اختر متجر MeMa للحصول على مزيج مثالي من التقاليد والحداثة، 
      مصنوع بعناية من أجلك فقط.`,

      'Yourstyle': 'زوقك هو شغفنا',

      'MeMaBlogs': `أهم المقالات`,

      'MeMaBlogsDesc': `دونة ميما للحصول على أحدث الاتجاهات ونصائح الموضة والرؤى من وراء الكواليس. مقالاتنا 
      تقدم نصائح قيمة حول كيفية تحقيق أقصى استفادة من مجموعة الحجاب الخاصة بك، والبقاء على اطلاع بأحدث اتجاهات الموضة،
      والحصول على الإلهام في المناسبات الخاصة. ابق على اتصال معنا وارفع مستوى أسلوبك من خلال نصائح الخبراء والمحتوى الحصري.`,

      'GetInTouch': 'تواصل معنا',

      'GetInTouchDesc': `نحن نحب أن نسمع منك! إذا كانت لديك أي أسئلة أو تعليقات أو مساعدة، تواصل مع فريقنا في متجر ميما. 
      سواء كنت بحاجة إلى مساعدة بشأن طلبك، أو لديك استفسار عن الأسلوب، أو ترغب فقط في مشاركة أفكارك،
      فنحن هنا لمساعدتك. اتصل بنا عبر البريد الإلكتروني أو الهاتف أو النموذج عبر الإنترنت، وسنقوم بالرد عليك على الفور.`,

      'FullName': 'الأسم بالكامل',
      'Email': 'البريد الإلكتروني',
      'OrderNumber': `رقم الطلب`,
      'Subject': `الموضوع`,
      'Message': `الرسالة`,
      'SubmitMessage': 'أرسل الرسالة',
      'NameIsRequired': 'الأسم مطلوب',
      'EmailIsRequired': 'البريد الإلكتروني مطلوب',
      'SubjectIsRequired': 'الموضوع مطلوب',
      'MessageIsRequired': 'الرسالة مطلوبه',
      'ShouldBeEmailPlease': 'من فضلك نريد البريد الإلكتروني',
      'Login': 'تسجيل الدخول',
      'EmailorPhoneNumber': 'البريد الإلكتروني أو رقم الهاتف',
      'Password': 'كلمة المرور',
      'ForgetPassword': 'هل نسيت كلمة المرور ؟',
      'SignIN': 'تسجيل الدخول',

      'CreateAccount': 'إنشاء حساب',
      'EmailOrPhonePlease': 'يجب إدخال كلمة المرور او الهاتف',
      'PasswordIsRequired': 'كلمة المرور مطلوبه',
      'ConfirmPassword': 'تأكيد كلمة المرور',
      'Phone': 'رقم الهاتف',
      'ConfirmPasswordRequired': 'من فضلك يجب تأكيد كلمة المرور',
      'MatchedIsRequired': 'التأكيد غير مطابق',
      'PhoneIsRequired': 'من فضلك يجب عليك إضافة رقم هاتفك',
      'PhoneValid': 'يجب أن يكون رقم الهاتف مصري أو سعودي',
      'Already': 'لديك حساب بالفعل',
      'ResetYourPassword': 'تغير كلمة مرورك',
      'BackToLogin': 'العودة إلى تسجيل الدخول',
      'SendMail': 'إرسال رابط التأكيد',
      'ChangePassword': 'غير كلمة المرور',

      'Cart': 'العربه',
      'EmptyCart': 'عربة التسوق لديك فارغه',
      'Clear': 'حذف جميع المنتجات',
      'Copon': 'كود الخصم',
      'CheckOut': 'شراء المنتجات',

      'WishList': `منتجاتك المفضلة`,
      'EmptyWishList': `لا يوجد منتجات`,
      'PleaseWishList': `من فضلك يجب عليك إنشاء حساب`,
      'MeMaAllProducts': `كل منتجات ميما`,
      'Filter': 'تصفية',
      'Products': 'منتجات',
      'and': 'و',
      'Price': 'سعر',
      'DiscoverOurBundle': `تفاصيل العرض`,

      'LE': 'جنيه',
      'SAR': 'ريال',

      'Remove': 'حذف المنتج',
      'Fibrac': 'الخامه',
      'OurVariants': 'المقاسات و الألوان',
      'MixedColor': 'خليط الوان',
      'Qunatatiy': 'الكمية',
      'InSotckReadyToShip': 'متاح و مستعد للشحن',
      'GetItBeforeFinished': 'احصل علية قبل النفاذ',
      'OutOfTheStock': 'غير متاح حاليا',
      'AddToCart': 'أضف إلي العربه',
      'BuyItNow': 'اشتريه الأن',
      'Reviews': 'أراء العملاء',
      'YouMayAlsoLike': 'يمكنك أيضا أن يعجبك منتجات أخري',

      'AddReview': `أضف تعليق`,
      'ReviewTitle': `عنوان التعليق`,
      'Review': 'تعليقك',
      'PleaseAddYourReviewTitle': `من فضلك نحتاج إلي عنوان التعليق`,
      'PleaseAddYourReview': `من فضلك نحتاج إلي تعليقك`,
      'GiveYourReviewTitle': `أضف عنوان تعليقك`,
      'GiveYourReview': `أضف تعليقك`,
      'YourAddition': 'سعر الإضافات',
      'BundleSProduct': `المنتجات التي يشملها العرض`,
      'YourAddress': 'عنوانك',
      'YourAddressIsRequired': 'من فضلك يجب إضافة عنوان منزلك',
      'placed': 'محجوز',
      'OrderDate': `تاريخ حجز الأوردر`,
      'OrderProducts': 'المنتجات المحجوزه',
      'Quantity': 'الكمية',
      'TotalAdditions': `سعر كل الاضافات`,
      'DiscountPrecentage': `نسبة الخصم`,
      'ReviewDesc': `كيف نستخدم بياناتك: لن نتصل بك إلا بشأن المراجعة التي تركتها، وإذا لزم الأمر فقط. من خلال تقديم
      رأيك، فإنك توافق على شروط القاضي.مي وسياسات الخصوصية والمحتوى`,
      'SendReview': 'أرسل رأيك',

      'Shipping': `ننصح العميل بالتأكد من فتح الشحنة بعد الاستلام و ابلاغنا بأقصي وقت 72 ساعة بأي مشكلة في الاوردر بعد فحص التصميمات جيدا لمساعدتكم في أي استرجاع او استبدال لان غير متاح أي استبدال او استرجاع بعدها و لاننا حريصين علي فحص كل المنتجات قبل شحنها
      و لكن مقدرين لطبيعة وجود نسبة من الخطأ لذلك ننصح بفحص الاوردر جيدا بعد استلامه لحفظ حقكم.الشحن و التوصيل يتم شحن جميع الطلبات في خلال 4-7 أيام عمل. ستتواصل معك شركة الشحن لترتيب موعد التسليم.
      جميع طلباتنا معبأة يدويًا ويتم شحنها بخالص الحب من القاهرة ، مصر.
      `,

      'ShippingTitle': 'سياسة الشحن',

      'ProductCare': 'العناية بالمنتج',

      'ProductCareDesc': `اغسلي كل وشاح على حدة دائمًا. تأكدي من استخدام الماء البارد وصابون خفيف
      مثل داوني. لا تستخدمي المبيض أو المنظفات القوية مثل جل برسيل. لا تنقعي وشاحك.`,

      'ProductCareDesc2': `العناية: لا تستخدمي دبابيس في أي 
      وشاح لديك، فهي تتلف وشاحك وتعلق به وتترك علامات دبابيس سيئة. يمكنك استخدام دبابيسنا المغناطيسية بدلاً 
      من ذلك أو لفها بشكل فضفاض. هذه هي التوصية العالمية للعناية بأي وشاح رقيق قد يكون لديك.`,

      'ProductCareDesc3': `اغسليه تحت الماء الجاري، وليس في حوض ممتلئ. اضغطي عليه برفق
      (لا تفركي الوشاح ولا تعصريه أبدًا!). ضعي الوشاح بشكل مسطح ليجف، لا تعلقيه حتى يحتفظ بشكله.`,

      'ProductCareDesc4': `كما أن وضعه بشكل مسطح يضمن عدم ملامسة الأجزاء الملونة المختلفة لبعضها البعض أثناء 
      البلل لتجنب انتقال اللون (ينطبق على جميع الأوشحة ذات الألوان المتدرجة والصبغة العميقة) 
      الكي: اكوي على درجة حرارة منخفضة ويفضل أن يكون هناك قطعة قماش أخرى بين الوشاح والمكواة.`,

      'SizeDescription': 'وصف الحجم',
      'Dashboard': 'إدارة الموقع',
      'LogOut': 'تسجيل الخروج',
      'MyAccount': 'الحساب الشخصي',
      'SeeYourOrders': 'تفقد طلباتك',
      'Egypt': 'مصر',
      'SaudiArabia': 'المملكه العربيه السعودية',
      'AccountDetails': 'أهم التفاصيل',
      'Address': 'عنوان المنزل',
      'SendAddress': 'إرسال العنوان',

      'Information': 'معلومات',
      'FAQ': 'اسئلة شائعه',
      'RefundAndExchange': `سياسة الأسترجاع`,
      'Connection': 'التواصل معنا',
      'Egy': 'الهاتف المصري',
      'Sud': 'الهاتف السعودي',
      'Rights': `الموقع ملك ميما ستور تصميم A To Z Tech`,
      'apartment': 'رقم الشقة',
      'city': 'المدينة',
      'state': 'البلد',
      'Coupon': 'كود الخصم',
      'PleaseApartmentIsAequired': `من فضلك رقم الشقة مطلوب`,
      'PleaseYourCountryIsRequired': `من فضلك البلد مطلوبة`,
      'ShippingCost': 'تكاليف الشحن',
      'FrequentlyAskedQuestions': `الاسئلة الشائعة`,
      'FreqDesc': `يعد موقع متجر ميما أمرًا بالغ الأهمية لتعزيز رضا العملاء. فهو يوفر إجابات سريعة وسهلة على الأسئلة الشائعة حول المنتجات والشحن
       والإرجاع وسياسات المتجر.ومن خلال تقديم هذا المورد المفيد، يضمن متجر متجر ميما أن العملاء يمكنهم حل مشكلاتهم بكفاءة دون الحاجة إلى الاتصال بالدعم، مما يؤدي 
       إلى تجربة تسوق أكثر سلاسة. بشكل منتظم
يتم تحديث قسم الأسئلة الشائعة بالمعلومات الأكثر صلة، ويعمل كمورد مرجعي لكل من العملاء الجدد والعائدين.`,
      'HowScarves': `كيف أغسل أوشحة ميما الخاصة بي وأعتني بها؟`,

      'HandClean': `التنظيف: يرجى التحقق من تعليما
      ت الغسيل المدرجة لكل وشاح في صفحة المنتج الخاصة به. إذا كانت هناك 
      حاجة إلى تنظيف البقع، تأكد من غسل البقعة المقصودة فقط، وأن الأجزاء الملونة المختلفة من الوشاح 
      لا تلمس على الإطلاق أثناء البلل، لتجنب نقل اللون. إذا يوصى بالغسيل، اغسل كل وشاح بمفرده دائمًا. 
      تأكد من استخدام الماء البارد والصابون المعتدل مثل داوني. لا تستخدم مواد التبييض أو المنظفات 
      القوية مثل برسيل جل. لا تنقع الوشاح. اغسله تحت الماء الجاري، وليس في حوض ممتلئ. اضغط عليه بلطف 
      (لا تفرك الوشاح، ولا تعصره أبدًا!). ضع الوشاح بشكل مسطح حتى يجف، ولا تعلقه حتى يحافظ على شكله. 
      ويضمن وضعه بشكل مسطح أيضًا عدم ملامسة الأجزاء الملونة المختلفة لبعضها البعض عندما تكون مبللة
       لتجنب نقل اللون (ينطبق على جميع الأوشحة المتدرجة والمصبوغة بعمق) الكي: الكي على درجة منخفضة 
      ويفضل وضع قطعة أخرى من القماش بين الوشاح والمكواة.العناية: لا تستخدمي الدبابيس في أي وشاح
       لديك، فهي تدمر أوشحتك وتعلق بها وتترك علامات دبابيس سيئة. يمكنك استخدام دبابيسنا المغناطيسية
       بدلاً من ذلك أو لفها بشكل غير محكم. هذه هي التوصية العالمية للعناية بأي وشاح رقيق قد يكون لديك.
     `,
      'HowToCancel?': 'كيف يمكنني تعديل أو إلغاء طلبي؟',
      'CancelDesc': `يرجى الاتصال بنا في حالة تغيير معلوماتك أو إلغاء طلبك على Instagram أو Facebook يرجى تزويدنا برقم طلبك ولقطة
       شاشة من طلبك تأكيد الطلب عبر البريد الإلكتروني حتى نتمكن من مساعدتك والتغييرات المطلوب تنفيذها.`,
      'CityRequired': 'من فضلك نحتاج المدينة',
      'PrivacyAndPolicy': 'الخصوصية والسياسة',
      'ShippingOrder': 'مصاريف الشحن',
      'REFUNDANDEXCHANGE': `سياسه الاسترجاع`,
      'RefundPolicyTitle': `سياسة الاستبدال والاسترجاع`,
      'RefunDesc': `يمكنك معاينة واسترجاع طلبك أثناء وجود المندوب عند التسليم. يرجى معاينة الطلب عند استلامه، وإذا لم يكن مطابقًا لتوقعاتك، يُرجى إرجاعه إلى المندوب فورًا 💕`,
      'NewArrival': `اخر منتجاتنا`,
      'RefunDesc2': `مع العلم انه غير متاح تسليم جزئي للأوردر 🎀`,
      'RefunDesc3': `يرجى ملاحظة أننا لا نقبل الاسترجاع بعد مغادرة المندوب وغير مسئولين عن الأوردر تمامًا عشان كده بنأكد علي حضرتك مراجعة الأوردر قبل الاستلام.`,
      'RefunDesc4': `هنستني رايك بعد الاستلام بإذن الله 🌸`,
      'RefunDesc5': `ملبوس العافية 🤍🤍`,
      'ToTalPrice': 'مجموع التكلفة',
      'ToTalCart': 'مجمل سعر العربه',
      'CouponPrec': 'مجمل الخصم',
      'subcartprice': 'سعر محنويات العربة',
      'ProductLink': `رابط المنتج`,
      'SoldOut': 'مباع بالكامل',
      'PasswordMustBeAtLeast9Characters': 'كلمة المرور يجب علي الاقل ان تكون 9 احرف',
      'PasswordMustBeAtMost15Characters': 'كلمة المرور يجب الا تتخطي 18 حرف',
      'ProductCartSmall': `يُغسل يدويًا باستخدام الماء البارد، استخدم صابونًا خفيفًا مثل الصابون الخاص.
       لا تستخدم المبيضات أو المنظفات القوية.، ويُعلق ليجف. يُكوى على نار متوسطة. قم بتخزين القماش
       المماثل في منطقة جيدة التهوية. استخدم فقط الدبابيس المغناطيسية لإطالة عمر المنتج.`,
      'ShippingSmall': `يتم شحن جميع الطلبات خلال 2-6 أيام عمل من تاريخالتقديم. ستتصل بك شركة الشحن لترتيب وقت التسليم. جميع طلباتنا معبأة يدويًا وشحنها بكل حب من القاهرة، مصر.`,
      'DepositNoteTitle': 'دفع الشحن',
      'OrderConfirmIntro': 'لتأكيد الطلب، يرجى تحويل قيمة الشحن إلى:',
      'PaymentVodafone': 'فودافون كاش باسم ميما',
      'PaymentInstapay': 'انستاباي باسم أحمد',
      'OrderPaidAtDelivery': 'وقيمة الطلب تُدفع عند الاستلام إن شاء الله 🌸',
      'ScreenshotConfirmNote': 'برجاء إرسال سكرين شوت من التحويل للتأكيد على نفس الرقم واتساب أو على صفحة الانستجرام أو الفيسبوك 🎀',
      'reset_image_note': 'يرجى تحميل صورة مرجعية لطلبك الإيداع.',
      'reset_image_note_label': 'ما هذا ؟',
      'reset_image_note_text': 'يرجى تحميل صورة مرجعية لطلبك الإيداع.',
      'reset_image_note_style': 'الأنماط المفضلة',
      'reset_image_note_color': 'الألوان المفضلة',
      'reset_image_note_embroidery': 'الطباعة المفضلة',
      'reset_image_note_custom': 'الأفكار المفضلة',
      'reset_image_optional': 'اختياري - تخطي إذا لم يكن لديك صورة مرجعية.',
      'reset_image_whatsapp': 'لا تستطيع الرفع؟ يمكنك إرسال صورة المرجع على واتساب بعد تأكيد الطلب إلى الرقم 01092525500 أو على صفحة الانستجرام أو الفيسبوك.',
      'ShippingZonesTitle': 'الشحن حسب مناطق التوصيل',
      'ShippingZonesIntro': 'سعر الشحن يعتمد على منطقة التوصيل. المبلغ الذي ترسله عبر فودافون كاش أو انستاباي هو رسوم الشحن فقط وليس إيداعًا للمنتج.',
      'ShippingZone1': 'المنطقة 1 (القاهرة، الجيزة): 70 جنيه',
      'ShippingZone2': 'المنطقة 2 (برج العرب، الإسكندرية): 80 جنيه',
      'ShippingZone3': 'المنطقة 3 (بورسعيد، الإسماعيلية، السويس، القليوبية، المنوفية، الشرقية، الغربية، الدقهلية، البحيرة، دمياط، كفر الشيخ): 75 جنيه',
      'ShippingZone4': 'المنطقة 4 (الفيوم، بني سويف، المنيا، أسيوط، سوهاج): 100 جنيه',
      'ShippingZone5': 'المنطقة 5 (قنا، الأقصر، أسوان): 110 جنيه',
      'ShippingTableZone': 'المنطقة',
      'ShippingTableAreas': 'المناطق',
      'ShippingTablePrice': 'السعر',
      'ShippingZone1Areas': 'القاهرة، الجيزة',
      'ShippingZone1Price': '70 جنيه',
      'ShippingZone2Areas': 'برج العرب، الإسكندرية',
      'ShippingZone2Price': '80 جنيه',
      'ShippingZone3Areas': 'بورسعيد، الإسماعيلية، السويس، القليوبية، المنوفية، الشرقية، الغربية، الدقهلية، البحيرة، دمياط، كفر الشيخ',
      'ShippingZone3Price': '80 جنيه',
      'ShippingZone4Areas': 'الفيوم، بني سويف، المنيا، أسيوط، سوهاج',
      'ShippingZone4Price': '100 جنيه',
      'ShippingZone5Areas': 'قنا، الأقصر، أسوان',
      'ShippingZone5Price': '110 جنيه',
      'OrderSummary': 'ملخص الطلب'
    }

  }

}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: 'en',

    interpolation: {
      escapeValue: false
    }, react: {
      useSuspense: true
    }
  })

export default i18n
